import {Locale} from "@/i18n/routing";
import {useTranslations} from "next-intl";

export const validateEmails = (form : HTMLFormElement) => {
  const email = (form.querySelector("input[name=\"email\"]") as HTMLInputElement)?.value;
  const confirmEmail = (form.querySelector("input[name=\"confirm_email\"]") as HTMLInputElement)?.value;
  const confirmEmailField = form.querySelector(".hs_confirm_email");
  const submitButton = form.querySelector("input[type=\"submit\"], button[type=\"submit\"]");

  // eslint-disable-next-line
  //Check if emails don"t match and confirm email field is not empty
  if (email !== confirmEmail && confirmEmail !== "" && confirmEmailField) {
    confirmEmailField?.querySelectorAll(".custom-email-error").forEach(el => el.remove());
    const ul = document.createElement("ul");
    ul.className = "no-list hs-error-msgs inputs-list custom-email-error";
    ul.setAttribute("role", "alert");
    const li = document.createElement("li");
    const label = document.createElement("label");
    label.className = "hs-error-msg hs-main-font-element";
    label.textContent = "Email and Confirm Email must match.";
    li.appendChild(label);
    ul.appendChild(li);
    // Append the error message to the confirm email field container
    confirmEmailField?.appendChild(ul);

    submitButton?.setAttribute("disabled", "true");
    return false;
  }

  // eslint-disable-next-line
  //if emails match and confirm email field is not empty, remove error messages
  if(confirmEmail !== ""){
    confirmEmailField?.querySelectorAll(".custom-email-error")?.forEach(el => el.remove());
  }

  submitButton?.removeAttribute("disabled");
  return true;

};

export const setupLiveEmailValidation = (form: HTMLFormElement) => {
  const emailInput = form.querySelector("input[name=\"email\"]") as HTMLInputElement;
  const confirmEmailInput = form.querySelector("input[name=\"confirm_email\"]") as HTMLInputElement;

  if (!emailInput || !confirmEmailInput) return;

  const validate = () => validateEmails(form);

  emailInput.addEventListener("input", validate);
  confirmEmailInput.addEventListener("input", validate);
};

export const validatePhone =(form : HTMLFormElement, locale: Locale, t: ReturnType<typeof useTranslations>) => {
  const phoneInput = form.querySelector("input[name=\"phone\"]") as HTMLInputElement;
  const submitButton = form.querySelector("input[type=\"submit\"], button[type=\"submit\"]");
  const phoneField = form.querySelector(".hs_phone");

  if (!phoneInput) return;

  // Accept only digits (remove non-digit characters)
  const phoneValue = phoneInput.value.trim();
  const phoneLength = phoneValue.replace(/[^0-9]/g, "").length;
  let isValidLength;
  let errorMsg;

  if (locale === "en-us") {
    isValidLength = phoneLength === 10;
    errorMsg = t("Phone Length Error");
  } else if (locale === "en-ca") {
    isValidLength = phoneLength === 10;
    errorMsg = t("Phone Length Error");
  } else if (locale === "en-au") {
    isValidLength = phoneLength === 9 || phoneLength === 10;
    errorMsg = t("Phone Length Error");
  } else if (locale === "en-nz") {
    isValidLength = phoneLength >= 7 && phoneLength  <= 10;
    errorMsg = t("Phone Length Error");
  } else {
    isValidLength = phoneLength >= 7;
    errorMsg = t("Phone Length Error");
  }
  // eslint-disable-next-line
  // Simple phone validation: check if the input is not empty
  if (phoneLength > 0 && !isValidLength) {
    // phoneField?.querySelectorAll(".custom-phone-error").forEach(el => el.remove());
    if (!phoneField?.querySelector("ul")) {
      const ul = document.createElement("ul");
      ul.className = "no-list hs-error-msgs inputs-list custom-phone-error";
      ul.setAttribute("role", "alert");
      const li = document.createElement("li");
      const label = document.createElement("label");
      label.className = "hs-error-msg hs-main-font-element";
      label.textContent = errorMsg;
      li.appendChild(label);
      ul.appendChild(li);
      phoneInput.classList.add("invalid", "error");
      phoneInput.parentElement?.parentElement?.appendChild(ul);
    }
    submitButton?.setAttribute("disabled", "true");
    // eslint-disable-next-line consistent-return
    return false;
  }

  // eslint-disable-next-line
  //if emails match and confirm email field is not empty, remove error messages
  if(phoneValue !== ""){
    phoneField?.querySelectorAll(".custom-phone-error")?.forEach(el => el.remove());
  }
  if(phoneValue.length === 0){
    phoneField?.querySelectorAll(".custom-phone-error")?.forEach(el => el.remove());
  }

  if (
    !phoneField?.querySelector("ul") &&
    phoneInput.classList.contains("invalid") &&
    phoneInput.classList.contains("error")
  ) {
    phoneInput.classList.remove("invalid", "error");
  }

  submitButton?.removeAttribute("disabled");
  // eslint-disable-next-line consistent-return
  return true;
};

export const setupLivePhoneValidation = (form: HTMLFormElement, locale: Locale, t: ReturnType<typeof useTranslations>) => {
  const phoneInput = form.querySelector("input[name=\"phone\"]") as HTMLInputElement;

  if (!phoneInput) return;

  const validate = () => validatePhone(form, locale, t);

  phoneInput.addEventListener("input", validate);
};